import { useCookies } from 'react-cookie'

import FloatingToolbar from 'components/elements/FloatingToolbar'
import AvatarCircle from 'components/user/AvatarCircle'

import styles from './floatingNavbar.module.scss'

type Props = {
  noHideOnScroll?: boolean
  swipeUpToOpenAccount?: boolean

  className?: string
}

const FloatingNavbar = ({ className, noHideOnScroll, swipeUpToOpenAccount }: Props) => {
  const [{ tbId: userId, tbUser: username, tbRootFolder: rootFolder, tbR: roles, tbAvatar: avatar }] = useCookies([
    'tbId',
    'tbUser',
    'tbRootFolder',
    'tbR',
    'tbAvatar',
  ])

  return (
    <FloatingToolbar
      noHideOnScroll={noHideOnScroll}
      gridColumns={5}
      className={className}
      options={[
        { icon: 'home', label: 'Home', href: '/' },
        { icon: 'folder outline', label: 'Decks', href: `/folders/${rootFolder}/` },
        {
          label: 'My shit',
          customIcon: <AvatarCircle className={styles.avatar} src={avatar} />,
          subComponent: <UserStuff />,
        },
        { icon: 'address book outline', label: 'Collection', href: `/collection/v2/${userId}/` },
        { icon: 'map marker alternate', label: 'Navigation', onClick: () => console.log('navigation') },
      ]}
    />
  )
}

export default FloatingNavbar

export const GenericFloatingNavbar = () => <FloatingNavbar className={styles.hideOnDesktop} swipeUpToOpenAccount />

const UserStuff = () => <div>User shit goes here</div>
